import { render, staticRenderFns } from "./certificateAddModal.vue?vue&type=template&id=048038fc&scoped=true&"
import script from "./certificateAddModal.vue?vue&type=script&lang=js&"
export * from "./certificateAddModal.vue?vue&type=script&lang=js&"
import style0 from "./certificateAddModal.vue?vue&type=style&index=0&id=048038fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048038fc",
  null
  
)

export default component.exports